<template>
  <div class="contact-type-selector">
    <div class="step-heading">{{ labels.get("What are you looking for") }}</div>
    <RadioButtonGroup>
      <RadioButton
        :label="labels.get('Product Contacts')"
        v-model="contactType"
        :value="config.contactTypes.product"
      ></RadioButton>
      <div class="row">
        <RadioButton 
          :label="labels.get('Contacts for Market Segments')"
          v-model="contactType"
          :value="config.contactTypes.marketSegment"
        ></RadioButton>
        <BusinessLineSearch
          class="bl-search"
          v-if="contactType === config.contactTypes.marketSegment"
          @change="onBusinessLineSelected"
        ></BusinessLineSearch>
      </div>
      <div class="row">
        <RadioButton
          :label="labels.get('Contacts for Business Units')"
          v-model="contactType"
          :value="config.contactTypes.businessUnit"
        ></RadioButton>
        <BusinessUnitSearch
          class="bl-search"
          v-if="contactType === config.contactTypes.businessUnit"
          @change="onBusinessUnitSelected"
        ></BusinessUnitSearch>
      </div>
      <RadioButton
        :label="labels.get('Clariant Locations')"
        v-model="contactType"
        :value="config.contactTypes.locations"
      ></RadioButton>
      <RadioButton
        :label="labels.get('Investor Relations')"
        v-model="contactType"
        :value="config.contactTypes.investorRelations"
      ></RadioButton>
      <RadioButton
        :label="labels.get('Career Contacts')"
        v-model="contactType"
        :value="config.contactTypes.careers"
      ></RadioButton>
      <RadioButton
        :label="labels.get('Media Contacts')"
        v-model="contactType"
        :value="config.contactTypes.media"
      ></RadioButton>
      <RadioButton
        :label="labels.get('Procurement Contact')"
        v-model="contactType"
        :value="config.contactTypes.procurement"
      ></RadioButton>
      <RadioButton 
        :label="labels.get('Other Contact')"
        v-model="contactType"
        :value="config.contactTypes.other"
      ></RadioButton>
    </RadioButtonGroup>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import { RadioButtonGroup, RadioButton } from "clariant-vue3-forms";
import BusinessLineSearch from "./BusinessLineSearch.vue";
import BusinessUnitSearch from "./BusinessUnitSearch.vue";

export default {
  name: "ContactTypeSelector",
  components: {
    RadioButtonGroup,
    RadioButton,
    BusinessLineSearch,
    BusinessUnitSearch
  },
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      contactType: 0,
      currentBusinessLine: "",
      currentBusinessUnit: "",
    };
  },
  watch: {
    contactType(val) {
      this.state.set("canAdvance", this.canAdvance());
    },
    currentBusinessLine(val) {
      this.state.set("canAdvance", this.canAdvance());
    },
    currentBusinessUnit(val) {
      this.state.set("canAdvance", this.canAdvance());
    },
  },
  mounted() {
    this.state.set("canAdvance", this.canAdvance());
  },
  methods: {
    getPrevStep() {
      return 0;
    },
    canAdvance() {
      return (
        this.contactType === this.config.contactTypes.product ||
        this.contactType === this.config.contactTypes.investorRelations ||
        this.contactType === this.config.contactTypes.careers ||
        this.contactType === this.config.contactTypes.media ||
        this.contactType === this.config.contactTypes.other ||
        this.contactType === this.config.contactTypes.locations ||
        this.contactType === this.config.contactTypes.procurement ||
        (this.contactType === this.config.contactTypes.marketSegment &&
          this.currentBusinessLine) ||
        (this.contactType === this.config.contactTypes.businessUnit &&
          this.currentBusinessUnit)
      );
    },
    getNextStep() {
      this.updateState();
      switch (this.contactType) {
        case this.config.contactTypes.marketSegment:
        case this.config.contactTypes.businessUnit:
        case this.config.contactTypes.investorRelations:
        case this.config.contactTypes.careers:
        case this.config.contactTypes.other:
          return 6;
        case this.config.contactTypes.media:
          return 3;
        default:
          return this.contactType;
      }
    },
    updateState() {
      let updatedState = null;
      if (this.contactType === this.config.contactTypes.investorRelations) {
        updatedState = {
          bu: this.config.investorRelationsTagId,
          bl: "",
          currentContact: "",
          currentProduct: "",
        };
      } else if (this.contactType === this.config.contactTypes.marketSegment) {
        updatedState = {
          bu: "",
          bl: this.currentBusinessLine,
          currentContact: "",
          currentProduct: "",
        };
      } else if (this.contactType === this.config.contactTypes.businessUnit) {
        updatedState = {
          bu: this.currentBusinessUnit,
          bl: "",
          currentContact: "",
          currentProduct: "",
        };
      } else if (this.contactType === this.config.contactTypes.careers) {
        updatedState = {
          bu: this.config.careersTagId,
          bl: "",
          currentContact: "",
          currentProduct: "",
        };
      } else if (this.contactType === this.config.contactTypes.other) {
        updatedState = {
          bu: "",
          bl: "",
          currentContact: this.config.defaultContactId,
          currentProduct: "",
        };
      }

      if (updatedState) {
        this.state.atomicUpdate("reload", updatedState);
      }
    },
    onBusinessLineSelected(id) {
      this.currentBusinessLine = id;
      this.currentBusinessUnit = "";
    },
    onBusinessUnitSelected(id) {
      this.currentBusinessLine = "";
      this.currentBusinessUnit = id;
    },
  },
};
</script>

<style scoped>

.cla-radio {
    margin: 17px 0 !important;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.row > * {
  width: 50%;
}

@media all and (max-width: 700px) {
    .row {
        flex-direction: column;
        align-items: flex-start;
    }
    .row > * {
        width: 100%;
    }
}

</style>
